"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _token = require("@jarvis/token");
var _react = _interopRequireWildcard(require("react"));
var _index = _interopRequireDefault(require("../ButtonBase/index"));
var _index1 = _interopRequireDefault(require("../Typography/index"));
var icons = _interopRequireWildcard(require("./icons"));
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  padding-left: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 7.5px 10px;\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  border-radius: 6px;\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 10px;\n  max-width: 430px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var TreeItem = /*#__PURE__*/ (0, _react).forwardRef(function(_param, ref) {
    var children = _param.children, id = _param.id, depth = _param.depth, questionNumber = _param.questionNumber, selected = _param.selected, onSelect = _param.onSelect, expanded = _param.expanded, onExpand = _param.onExpand, hideExpandButton = _param.hideExpandButton, props = _objectWithoutProperties(_param, [
        "children",
        "id",
        "depth",
        "questionNumber",
        "selected",
        "onSelect",
        "expanded",
        "onExpand",
        "hideExpandButton"
    ]);
    var select = (0, _react).useCallback(function() {
        onSelect(id, selected === "none" ? true : false);
    }, [
        id,
        onSelect,
        selected
    ]);
    var expand = (0, _react).useCallback(function() {
        onExpand(id, !expanded);
    }, [
        expanded,
        id,
        onExpand
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime).jsxs(OutsideBox, _objectSpread({
        ref: ref,
        depth: depth
    }, props, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime).jsxs(ContentBox, {
                selected: selected,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime).jsxs(_index.default, {
                        "data-testid": "TreeItem_selectButton",
                        onClick: select,
                        children: [
                            function() {
                                switch(selected){
                                    case "all":
                                        return icons.checkedCheckbox;
                                    case "partial":
                                        return icons.indeterminateCheckbox;
                                    case "none":
                                        return icons.emptyCheckbox;
                                }
                            }(),
                            /*#__PURE__*/ (0, _jsxRuntime).jsxs(ContentText, {
                                variant: "body2",
                                as: "div",
                                children: [
                                    "(",
                                    id,
                                    ") ",
                                    children
                                ]
                            })
                        ]
                    }),
                    hideExpandButton ? /*#__PURE__*/ (0, _jsxRuntime).jsx(_react.Fragment, {}) : /*#__PURE__*/ (0, _jsxRuntime).jsx(ExpandIconButtonBase, {
                        onClick: expand,
                        "data-testid": "TreeItem_ExpandButton",
                        children: expanded ? icons.bottomArrow : icons.rightArrow
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime).jsxs(_index1.default, {
                variant: "body2",
                colorVariant: _token.COLOR_TEXT_4,
                children: [
                    questionNumber,
                    " Questions"
                ]
            })
        ]
    }));
});
var _default = /*#__PURE__*/ _react.default.memo(TreeItem);
exports.default = _default;
var OutsideBox = _styled.default.div(_templateObject(), function(param) {
    var depth = param.depth;
    return "".concat((depth !== null && depth !== void 0 ? depth : 0) * 10, "px");
});
var ExpandIconButtonBase = (0, _styled).default(_index.default)(_templateObject1());
var ContentBox = _styled.default.div(_templateObject2(), function(props) {
    return props.selected === "all" ? _token.COLOR_BG_CARD_2 : "none";
}, function(props) {
    return props.selected === "all" ? _token.COLOR_BG_CARD_4 : _token.COLOR_BG_CARD_3;
});
var ContentText = (0, _styled).default(_index1.default)(_templateObject3());
TreeItem.displayName = "TreeItem";
